import { render, staticRenderFns } from "./modalAddEditorials.vue?vue&type=template&id=dcc79d5e&"
import script from "./modalAddEditorials.vue?vue&type=script&lang=js&"
export * from "./modalAddEditorials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports